
export default {
	props: ['projects','project_selected_slug','current_slug'],
}
